


























































import NonCommodityStepperWidget from '@/components/widgets/NonCommodityStepperWidget.vue';
import NonCommodityProductFacade from '@/models/NonCommodityProductFacade';
import { default as Component } from 'vue-class-component';
import { TranslateResult } from 'vue-i18n';
import NonCommodityStep from '@/models/NonCommodityStep';
import iocContainer from '@/container/IocContainer';
import Format from '@/interfaces/Format';
import SERVICES from '@/container/Services';
import ProductData from '@/interfaces/ProductData';
import ThgServiceElliDefault from '@/models/thg/ThgServiceElliDefault';

const formatProvider = iocContainer.get<Format>(SERVICES.FORMAT);

@Component({
  filters: {
    euro: formatProvider.euro()
  }
})
export default class StepperWidget extends NonCommodityStepperWidget {
  public getStepHeaderTitle(step: NonCommodityStep): TranslateResult {
    let title: string = this.$t('stepper.noncommodity.header.' + step.widget).toLocaleString();
    if (step.widget === 'review') {
      title = this.$t('stepper.noncommodity.header.' + step.widget + (step.isDone ? '.done' : '')).toLocaleString();
    }
    if (step.widget === 'registration') {
      const product = this.store.getters.getSelectedProduct;
      if (product && product.productCode.toLowerCase().includes('bonus')) {
        title = this.$t('stepper.noncommodity.header.eco.' + step.widget).toLocaleString();
      } else {
        return this.$t('stepper.noncommodity.header.' + step.widget, {
          price: formatProvider.euro()(this.productPrice ?? 0),
          productName: ''
        }).toLocaleString();
      }
    }
    title = title.replace('{companyName}', this.sessionState.billingCompany ?? '');
    return title;
  }

  get productPrice(): number | undefined {
    if (!this.productData || this.productData.productId == 0) {
      return 0;
    }
    return this.thgConfig.isCustomerTypeBusiness
      ? this.nonCommodityProduct.getBasePrice(
          this.$store.getters.getSelectedVehicleType,
          this.thgConfig.selectedYearArray
        )
      : this.nonCommodityProduct.getBasePriceBrutto(
          this.$store.getters.getSelectedVehicleType,
          this.thgConfig.selectedYearArray
        );
  }

  public get thgConfig(): ThgServiceElliDefault {
    return ThgServiceElliDefault.instance;
  }

  public get nonCommodityProduct(): NonCommodityProductFacade {
    return NonCommodityProductFacade.withData(this.productData);
  }

  protected get productData(): ProductData {
    return this.store.state.nonCommodityProductData;
  }

  get getStepHeaderDescription(): TranslateResult {
    const step = this.currentStep;
    const product = this.store.getters.getSelectedProduct;
    const replaceData = {
      price: formatProvider.euro()(this.productPrice ?? 0),
      productName: product ? product.name : ''
    };

    if (step.widget === 'review') {
      return this.$t(
        'stepper.noncommodity.header.description.' +
          step.widget +
          (step.isDone ? '.done' : '') +
          (this.isFleetFlow ? '.fleet' : ''),
        replaceData
      );
    } else if (step.widget === 'registration') {
      if (product && product.productCode.toLowerCase().includes('bonus')) {
        return this.$t('stepper.noncommodity.header.description.eco.' + step.widget, replaceData);
      }
      if (product && product.productCode.toLowerCase().includes('voucher')) {
        return this.$t('stepper.noncommodity.header.description.voucher.' + step.widget, replaceData);
      }
    } else if (step.widget === 'product' && this.isFleetFlow) {
      return this.$t('stepper.noncommodity.header.description.fleet.' + step.widget, replaceData);
    }
    return this.$t('stepper.noncommodity.header.description.' + step.widget, replaceData);
  }
}
